// client/src/config.js
import CoinFlipABI from './contracts/CoinFlip.json';
import GameTokenABI from './contracts/GameToken.json';
import FaucetABI from './contracts/Faucet.json';

export const coinFlipContractConfig = {
    address: "0x430BEd703975548d4eB4d22e5DC2E094040F1C3d", // Ganti ini
    abi: CoinFlipABI.abi,
};

export const gameTokenContractConfig = {
    address: "0x739789B3A8f246D8Da6F834Ddb0f9496507277a2", // Ganti ini
    abi: GameTokenABI.abi,
};

export const faucetContractConfig = {
    address: "0x34481E1d63d0500D285035aD2e98e60259b866C5", // Ganti ini
    abi: FaucetABI.abi,
};